import React from 'react'
import './solarmapview-style.scss'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { useNavigate } from 'react-router-dom'
import TextField from '@material-ui/core/TextField'
import SearchIcon from '@material-ui/icons/Search'
import InputAdornment from '@mui/material/InputAdornment'
import ImportExportIcon from '@mui/icons-material/ImportExport'
import IconButton from '@mui/material/IconButton'
import useSolarMapViewStyles from './styles.js'

const SolarMapView = () => {
  const classes = useSolarMapViewStyles()
  const navigate = useNavigate()

  const handleTechnicalView = () => {
    navigate('/TechnicalView')
  }
  const handleSolarListView = () => {
    navigate('/solarplantlist')
  }

  return (
    <div className={classes.root} id="solarmapview">
      <Box
        sx={{
          '& .MuiTextField-root': { m: 1, width: '100%' },
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <div className="align_start">
              <div className="w80">
                <div className="searchbar">
                  <TextField
                    placeholder="Search..."
                    disableUnderline
                    InputProps={{
                      disableUnderline: true,
                      endAdornment: (
                        <InputAdornment position="start" className="pointer">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
              </div>
              <div className="w20 ml_10">
                <IconButton>
                  <ImportExportIcon className="sort_i" />
                </IconButton>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={8}>
            <div className="align_end wrap">
              <div className="mtn_8 mr_8">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={['DatePicker']}>
                    <DatePicker
                      className={classes.datePicker}
                      format="DD-MM-YYYY"
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </div>

              <div className="map_list_toggle" onClick={handleSolarListView}>
                <label class="switch">
                  <input type="checkbox" checked />
                  <span class="slider"></span>
                </label>
              </div>
            </div>
          </Grid>
        </Grid>
      </Box>
      <hr className="brdr_btm" />
      <div>
        <iframe
          src="https://www.google.com/maps/embed/v1/place?key=AIzaSyDELXYU2T40qihoAZJyr4q0ti-Vui1FUsQ&q=Space+Needle,Seattle+WA"
          width="100%"
          height="500"
          frameBorder="0"
          style={{ border: 0 }}
          allowFullScreen=""
          aria-hidden="false"
          tabIndex="0"
        ></iframe>
      </div>
    </div>
  )
}

SolarMapView.propTypes = {}

export default SolarMapView
